// extracted by mini-css-extract-plugin
export default {"card":"Card_card__4lys7","cardHeader":"Card_cardHeader__dSv1r"};